/**
 * Schema of CargaResponsavel
 * @author Simpli CLI generator
 */
import {cnpj, cpfOrCnpj, InputType, Schema} from 'simpli-web-sdk'
import {$, phone} from 'simpli-web-sdk'
import CargaResponsavel from '@/model/resource/CargaResponsavel'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'

export default (model: CargaResponsavel): Schema => ({
  nome: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('nome'),
          value: model.nome || $.t('app.notInformed'),
        },
      },
    ],
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  cnpj: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('cnpj'),
          value: cpfOrCnpj(model.cnpj) || $.t('app.notInformed'),
        },
      },
    ],
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  telefone: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('telefone'),
          value: phone(model.telefone) || $.t('app.notInformed'),
        },
      },
    ],
    input: InputType.PHONE,
    meta: {
      required: false,
    },
  },

  email: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('email'),
          value: model.email || $.t('app.notInformed'),
        },
      },
    ],
    input: InputType.EMAIL,
  },

  endereco: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('endereco'),
          value: model.endereco && model.endereco.toString() || $.t('app.notInformed'),
        },
      },
    ],
    input: InputType.SELECT,
  },
})
